export default __webpack_public_path__ + "fonts/Gotham-Light.d029172cd1a661a55d172e7cd4fc3e80.svg";